var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#192949",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82877 3.5C7.39622 3.5 6.98474 3.68672 6.6999 4.01224L6.12371 4.67075C5.94187 4.87857 5.96293 5.19445 6.17075 5.37629C6.37857 5.55813 6.69445 5.53707 6.87629 5.32925L7.45248 4.67075C7.54742 4.56224 7.68459 4.5 7.82877 4.5H12.1712C12.3154 4.5 12.4526 4.56224 12.5475 4.67075L13.1237 5.32925C13.3056 5.53707 13.6214 5.55813 13.8293 5.37629C14.0371 5.19445 14.0581 4.87857 13.8763 4.67075L13.3001 4.01224C13.0153 3.68672 12.6038 3.5 12.1712 3.5H7.82877ZM4 6.5C4 6.22386 4.22386 6 4.5 6H5H6H14H15H15.5C15.7761 6 16 6.22386 16 6.5C16 6.77614 15.7761 7 15.5 7H15V15C15 16.1046 14.1046 17 13 17H7C5.89543 17 5 16.1046 5 15V7H4.5C4.22386 7 4 6.77614 4 6.5ZM6 7H14V15C14 15.5523 13.5523 16 13 16H7C6.44772 16 6 15.5523 6 15V7ZM8 9.08826C8 8.81211 8.22386 8.58826 8.5 8.58826C8.77614 8.58826 9 8.81211 9 9.08826V12.7941C9 13.0703 8.77614 13.2941 8.5 13.2941C8.22386 13.2941 8 13.0703 8 12.7941V9.08826ZM11.5 8.58826C11.2239 8.58826 11 8.81211 11 9.08826V12.7941C11 13.0703 11.2239 13.2941 11.5 13.2941C11.7761 13.2941 12 13.0703 12 12.7941V9.08826C12 8.81211 11.7761 8.58826 11.5 8.58826Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.8e2c6e344f7d9f041a9b15746e043175.svg";
export { ForwardRef as ReactComponent };